<template>
  <div class="swiper-slide panel-item">
    <a :href="stay.place_url" target="_blank" rel="nofollow">
      <div class="panel-header">
        <template v-if="isLazy">
          <img
            :data-src="stay.image_url"
            :alt="stay.name"
            class="swiper-lazy"
          />
          <div class="swiper-lazy-preloader"></div>
        </template>
        <template v-else>
          <img :src="stay.image_url" :alt="stay.name" />
        </template>
      </div>
      <div class="panel-body">
        <kcs-area-label
          :prefecture="stay.prefecture"
          :city="stay.city"
          facility-type="宿泊施設"
        />
        <h3 class="panel-name">{{ stay.name }}</h3>
        <p class="panel-lead hide-sp">{{ stay.introduction }}</p>
        <p class="panel-point">
          <kcs-rating :rating="stay.rating || 0" />
        </p>
        <p class="btn-wrapper">
          <span class="btn fac">この施設を詳しく見る</span>
        </p>
      </div>
    </a>
  </div>
</template>

<script>
import KcsRating from '@/components/atoms/kcs-rating.vue'
import KcsAreaLabel from '@/components/atoms/kcs-area-label.vue'
export default {
  components: {
    KcsAreaLabel,
    KcsRating
  },
  props: {
    stay: {
      type: Object,
      required: true
    },
    isLazy: {
      type: Boolean,
      default: true
    }
  }
}
</script>
